// Prevent multiple event listeners
if (window.membershipUpsellLoaded) {
  console.log("Membership upsell script already loaded");
} else {
  window.membershipUpsellLoaded = true;
  
  console.log("Loading membership upsell functionality");

  // Test if script loads
  console.log("Membership upsell script loaded successfully!");

  // Use event delegation on document to handle dynamically loaded buttons
  document.addEventListener("click", async (event) => {
  console.log("Click detected on:", event.target);
  
  const btn = event.target.closest(".drawer-upsell-button");
  if (!btn) {
    console.log("No .drawer-upsell-button found");
    return;
  }
  
  if (btn.disabled) {
    console.log("Button is disabled");
    return;
  }

  // Prevent default behavior
  event.preventDefault();
  event.stopPropagation();
  
  console.log("Membership upsell button clicked:", btn);

  const variantId = parseInt(btn.dataset.membershipVariant);
  const sellingPlanId = parseInt(btn.dataset.membershipSellingPlan);

  console.log("Button data attributes:", {
    membershipVariant: btn.dataset.membershipVariant,
    membershipSellingPlan: btn.dataset.membershipSellingPlan,
    variantId: variantId,
    sellingPlanId: sellingPlanId
  });

  if (!variantId || isNaN(variantId)) {
    console.error("Invalid variant ID:", variantId);
    alert("Configuration error: Invalid variant ID");
    return;
  }

  // Store original text before any operations
  const originalText = btn.textContent;

  // Check if membership is already in cart
  try {
    const currentCart = await fetch("/cart.js").then((r) => r.json());
    const alreadyExists = currentCart.items.find((item) => item.variant_id === variantId);
    if (alreadyExists) {
      console.log("Membership already in cart");
      btn.textContent = "Already Added!";
      setTimeout(() => {
        if (btn && btn.parentNode) {
          btn.textContent = originalText;
        }
      }, 1500);
      return;
    }
  } catch (e) {
    console.log("Could not check existing cart, proceeding with add");
  }

  const payload = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };

  if (!isNaN(sellingPlanId)) {
    payload.items[0].selling_plan = sellingPlanId;
  }

  btn.disabled = true;
  btn.textContent = "Adding...";

  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!res.ok) throw new Error("Cart add failed");

    const cart = await fetch("/cart.js").then((r) => r.json());
    const exists = cart.items.find((item) => item.variant_id === variantId);
    if (!exists) throw new Error("Membership not found in cart");

    btn.textContent = "Added!";
    
    // Try multiple refresh approaches
    console.log("Triggering cart refresh...");
    
    // Method 1: Theme's cart:refresh event
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    
    // Hide the upsell with smooth transition after a small delay to ensure refresh
    setTimeout(() => {
      const upsell = btn.closest(".drawer-membership-upsell");
      if (upsell) {
        upsell.classList.add('removing');
        setTimeout(() => {
          if (upsell.parentNode) {
            upsell.remove();
          }
        }, 300);
      }
    }, 100);
    
    // Method 2: Fallback - force reload mini cart after a delay
    setTimeout(() => {
      const miniCart = document.querySelector('#mini-cart');
      if (miniCart && typeof miniCart._rerenderCart === 'function') {
        console.log("Calling _rerenderCart method");
        miniCart._rerenderCart({});
      } else {
        console.log("Attempting manual cart refresh");
        // Method 3: Manual refresh of mini-cart
        fetch(`/cart?section_id=mini-cart`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newCart = doc.querySelector('#mini-cart');
            const currentCart = document.querySelector('#mini-cart');
            if (newCart && currentCart) {
              currentCart.innerHTML = newCart.innerHTML;
              console.log("Mini-cart manually refreshed");
            }
          })
          .catch(err => console.error("Manual cart refresh failed:", err));
      }
    }, 800);

  } catch (err) {
    console.error("[Membership Upsell Error]", err);
    btn.textContent = "Error";
    alert("Could not add membership. Please try again.");
  }

  setTimeout(() => {
    // Only reset button if it's still in the DOM
    if (btn && btn.parentNode) {
      btn.textContent = originalText;
      btn.disabled = false;
    }
  }, 2000);
});

} // End of membershipUpsellLoaded check
